import React, { useEffect, useRef, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import { useBilling } from '../../context/BillingContext';
import BillingShell from '../../layouts/BillingShell';

const API = process.env.REACT_APP_API_URL || 'http://localhost:5001/api';

const BillingTokenGate = ({ children = null }) => {
  const [searchParams] = useSearchParams();
  const expired = searchParams.get('expired') === '1';
  const { isAuthenticated, setBillingSession } = useBilling();
  const navigate = useNavigate();
  const [error, setError] = useState(null);
  const [exchanging, setExchanging] = useState(false);
  const initiated = useRef(false);

  useEffect(() => {
    if (initiated.current) return;

    if (isAuthenticated) {
      navigate('/billing/dashboard', { replace: true });
      return;
    }

    const token = searchParams.get('token');
    if (!token) return;

    initiated.current = true;
    const exchange = async () => {
      setExchanging(true);
      try {
        const res = await axios.post(
          `${API}/auth/billing-token/exchange`,
          { billingToken: token }
        );
        setBillingSession(res.data);
        navigate('/billing/dashboard', { replace: true });
      } catch (err) {
        console.warn('[BillingTokenGate] exchange failed', { status: err?.response?.status });
        setError(
          'This link has expired or has already been used. ' +
          'Please return to the app and try again.'
        );
        setExchanging(false);
      }
    };

    exchange();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  if (exchanging) {
    return (
      <BillingShell>
        <p style={{ color: '#555555', fontSize: '15px' }}>Loading your billing information...</p>
      </BillingShell>
    );
  }

  return (
    <BillingShell>
      {error ? (
        <p style={{ color: '#B00020', fontSize: '15px' }}>{error}</p>
      ) : (
        children ?? (
          expired
            ? <p style={{ color: '#B00020', fontSize: '15px' }}>Your session has expired. Please return to the app.</p>
            : <p style={{ color: '#555555', fontSize: '15px' }}>
                To manage your billing, open the LifeChiAI app and tap <strong>Manage Billing</strong>.
              </p>
        )
      )}
    </BillingShell>
  );
};

export default BillingTokenGate;
